import styles from "./FromKonsultasi.module.css"
import { Card, Form, Input, Select } from "antd"
import ButtonGreenOriginal from "../../../../../components/ButtonGreen/Original"
import dropdownSelect from "./asset/dropdown-select.svg"
import { useState } from "react"

const { TextArea } = Input

const FromKonsultasi = () => {
  const [form] = Form.useForm()
  const [selectedProgram, setSelectedProgram] = useState(null)

  const handleProgramChange = (value) => {
    setSelectedProgram(value)
    form.resetFields([
      "namaPerusahaan",
      "posisi",
      "namaKampus",
      "status",
      "fakultas",
    ])
  }


const handleSubmit = (values) => {
  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase())
  }
 
  const phoneNumber = "6287897730250"

  let message =
    "Halo, Bu Nara! \nSaya ingin melakukan konsultasi atau meminta penawaran terkait layanan di Mindo Education. Berikut informasi saya: \n\n"

  message += `Nama Lengkap: *${capitalizeWords(values.namaLengkap)}*\n`
  message += `Program: *${
    values.program === "campus partner"
      ? "Campus Partner"
      : values.program === "inhouse training"
      ? "In-house Training"
      : "Konsultasi & Pendampingan Sertifikasi"
  }*\n`

  if (
    values.program === "inhouse training" ||
    values.program === "konsultasi & pendampingan sertifikasi"
  ) {
    message += `Nama Perusahaan: *${values.namaPerusahaan}*\n`
    message += `Posisi/Jabatan: *${values.posisi}*\n`
  }

  if (values.program === "campus partner") {
    message += `Nama Perguruan Tinggi: *${values.namaKampus}*\n`
    message += `Status: *${capitalizeWords(values.status)}*\n`
    message += `Fakultas/Program Studi: *${capitalizeWords(values.fakultas)}*\n`
  }

  if (values.deskripsi) {
    message += `\nDeskripsikan Kebutuhan Anda:\n${values.deskripsi}\n`
  }

  const encodedMessage = encodeURIComponent(message)
  const waUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`


  
  window.open(waUrl, "_blank")

  form.resetFields()


  setSelectedProgram(null)
}



  return (
    <>
      <Card className={styles.cardFrom} style={{ borderRadius: 16 }}>
        <h3 className={styles.fromTitle}>
          Form Konsultasi dan Permintaan Penawaran
        </h3>

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Nama Lengkap"
            name="namaLengkap"
            rules={[
              { required: true, message: "Silakan isi nama lengkap Anda" },
            ]}>
            <Input
              style={{ borderRadius: 6, padding: 12 }}
              placeholder="Nama Lengkap"
            />
          </Form.Item>

          <Form.Item
            label="Pilihan Program"
            name="program"
            rules={[{ required: true, message: "Silakan pilih program" }]}>
            <Select
              suffixIcon={
                <img
                  src={dropdownSelect}
                  alt="dropdown"
                  style={{ width: 20, height: 20 }}
                />
              }
              className={styles.customSelect}
              placeholder="Pilih Salah Satu Program"
              onChange={handleProgramChange}
              options={[
                { label: "In-house Training", value: "inhouse training" },
                {
                  label: (
                    <span className={styles.labelBreak}>
                      Konsultasi & Pendampingan Sertifikasi
                    </span>
                  ),
                  value: "konsultasi & pendampingan sertifikasi",
                },
                { label: "Campus Partner", value: "campus partner" },
              ]}
            />
          </Form.Item>

          {(selectedProgram === "inhouse training" ||
            selectedProgram === "konsultasi & pendampingan sertifikasi") && (
            <>
              <Form.Item
                label="Nama Perusahaan"
                name="namaPerusahaan"
                rules={[{ required: true, message: "Isi nama perusahaan" }]}>
                <Input
                  style={{ borderRadius: 6, padding: 12 }}
                  placeholder="Nama Perusahaan"
                />
              </Form.Item>

              <Form.Item
                label="Posisi/Jabatan"
                name="posisi"
                rules={[
                  { required: true, message: "Isi posisi atau jabatan Anda" },
                ]}>
                <Input
                  style={{ borderRadius: 6, padding: 12 }}
                  placeholder="Contoh: HR Manager, Staff QC, dll"
                />
              </Form.Item>
            </>
          )}

          {selectedProgram === "campus partner" && (
            <>
              <Form.Item
                label="Nama Perguruan Tinggi"
                name="namaKampus"
                rules={[
                  { required: true, message: "Isi nama perguruan tinggi" },
                ]}>
                <Input
                  style={{ borderRadius: 6, padding: 12 }}
                  placeholder="Nama Perguruan Tinggi"
                />
              </Form.Item>

              <Form.Item
                label="Status"
                name="status"
                rules={[{ required: true, message: "Pilih status Anda" }]}>
                <Select
                  suffixIcon={
                    <img
                      src={dropdownSelect}
                      alt="dropdown"
                      style={{ width: 20, height: 20 }}
                    />
                  }
                  className={styles.customSelect}
                  placeholder="Pilih Status"
                  options={[
                    { label: "Dosen", value: "dosen" },
                    { label: "Mahasiswa", value: "mahasiswa" },
                    {
                      label: "Pengurus Himpunan Jurusan",
                      value: "pengurus himpunan jurusan",
                    },
                    {
                      label: "Tenaga Kependidikan Lainnya",
                      value: "tendik",
                    },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label="Fakultas / Program Studi"
                name="fakultas"
                rules={[
                  {
                    required: true,
                    message: "Isi fakultas atau program studi",
                  },
                ]}>
                <Input
                  style={{ borderRadius: 6, padding: 12 }}
                  placeholder="Contoh: Fakultas Teknologi Pangan / Teknik Informatika"
                />
              </Form.Item>
            </>
          )}

          <Form.Item label="Deskripsikan Kebutuhan Anda" name="deskripsi">
            <TextArea
              style={{ borderRadius: 6, padding: 12 }}
              rows={4}
              placeholder="Tulis kebutuhan Anda di sini"
            />
          </Form.Item>

          <Form.Item>
            <ButtonGreenOriginal
              namaBtn="Konsultasikan Sekarang"
              onClick={form.submit}
            />
          </Form.Item>
        </Form>
      </Card>
    </>
  )
}

export default FromKonsultasi
